import { useQuery } from 'react-query';
import { SensorTransport } from './SensorTransportProvider';
import { fetchAlarmedBoxes, fetchBoxStatus, fetchBoxTimeline } from '../core/_requests';

export const httpPollingTransport: SensorTransport = {
  useAlarmedBoxes(filters) {
    return useQuery(
      ['sensors-v2', 'alarmed-boxes', filters],
      () => fetchAlarmedBoxes(filters),
      {
        refetchInterval: 60_000,
        refetchIntervalInBackground: false,
        refetchOnWindowFocus: true,
        keepPreviousData: true,
      },
    );
  },
  useBoxTimeline(box_id, filters) {
    return useQuery(
      ['sensors-v2', 'box-timeline', box_id, filters],
      () => fetchBoxTimeline(box_id as number, filters),
      {
        enabled: box_id !== null,
        refetchInterval: 60_000,
        refetchIntervalInBackground: false,
        refetchOnWindowFocus: true,
        keepPreviousData: true,
      },
    );
  },
  useBoxStatus(box_id) {
    return useQuery(
      ['sensors-v2', 'box-status', box_id],
      () => fetchBoxStatus(box_id as number),
      { enabled: box_id !== null, refetchOnWindowFocus: false },
    );
  },
};
